import Http from './Http'

class InterestSearchService extends Http {
  constructor () {
    super('/interest')
  }

  async search (q) {
    const data = await this.show(`search?q=${q}`)
    return data
  }
}

export default new InterestSearchService()
